import React from 'react'
import { Breadcrumbs } from "@material-tailwind/react";
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import SidebarTop from '../SidebarTop';
import { MdPostAdd } from "react-icons/md";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  IconButton,
  Tooltip,
  Typography
} from "@material-tailwind/react";
import { RxDotsVertical } from "react-icons/rx";
import { VscSend } from "react-icons/vsc";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Image_Profil_User from '../../../ASSETS/user/Image_Profil_User.jpg';
import { FaChevronDown, FaUser } from 'react-icons/fa6';
import { io } from 'socket.io-client';
import { FiDownload } from 'react-icons/fi';

function Message() {
  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });
  
  const receiverId = data.userId;
  //console.log(data);
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [comment, setComment] = useState("")
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState([]);
  const [newConversation, setNewConversation] = useState([]);
  const [senders, setSenders] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [discussion,setDiscussion] = useState([]);
  const [receive,setReceive] = useState({})
  const [searchP,setSearchP] = useState("")
  const [originalConversations, setOriginalConversations] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [fileFront,setFilFront] = useState(null);
  const [docFile, setDocFile] = useState(null);
  const [receveurNode,setReceveurNode] = useState({})
  const [bulb,setBulb] = useState(false);

  function getImageMimeType(base64) {
  if (base64.startsWith("/9j/")) return "image/jpeg";
  if (base64.startsWith("iVBORw0KGgo")) return "image/png";
  if (base64.startsWith("R0lGOD")) return "image/gif";
  if (base64.startsWith("UklGR")) return "image/webp";
  return "image/png"; // fallback
}


  const socket = io("http://localhost:3001", {
     transports: ["websocket"], 
  withCredentials: true
});
 

  const messageObject = {
  id_conversation: null, // sera rempli côté serveur
  date_conversation: new Date().toISOString(),
  id_message_sent: data.userId,
  message: comment ? comment : message  ,
  respondent_az_id: receive?.Customers_Numbers, // ou la valeur si tu l'as
  Picture: data?.image ? data.image : "",
  sender: data.userId,
  senderName:data?.userName,
  senderLastName: data?.userLastname,
  senderPicture: data?.image ? data.image : "",
  receiver: receive?.Customers_Numbers,
  receiverName: receive?.Names,
  receiverLastName: receive?.LastName,
  receiverPicture: receive?.Picture ? receive.Picture :  "",
  file: fileFront, // Si c'est un PDF, on n'envoie pas de fichier image
  doc_file: docFile
};

  const getSenderMessages = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/sender/all/recu/${data.userId}`);

        // On convertit l'objet {3: [...], 5: [...]} en un tableau à plat
        const rawData = response.data?.data || {};
        const messages = Object.values(rawData).flat();

        //console.log(messages)

        setSenders(messages); // Maintenant senders est un tableau 👍
    } catch (error) {
        console.error("Error fetching messages:", error);
    }
  };

  const conversation = (receiverId, senderId) => {
        async function ShowConversation() {
            try {
                if(senderId){
                    const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/message/recu/${receiverId}/${senderId}`);
                    //console.log("messages: ", res.data.messages);
                    setReceive(res.data.sender)
                    setConversations(res.data);
                }
              
            } catch (err) {
                console.error("Error fetching conversation:", err);
            }
        }ShowConversation();
    };

    async function NewConversation() {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/new/conversation`);
                //console.log("users: ", res.data.data);
                setNewConversation(res.data.data);
                setOriginalConversations(res.data.data)
            } catch (err) {
                console.error("Error fetching conversation:", err);
            }
    };

    async function newDiscussion(receiverId,id) {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/new/discussion/${id}`);
                //console.log("users: ", res.data.data);
                 //setNewConversation(res.data.data);
                 setIsMenuOpen(!isMenuOpen);
                 const findUser = newConversation.find((custoNumber)=>custoNumber.Customers_Numbers === id)
                 setReceive(findUser)
                 //console.log(findUser)
                 setDiscussion(res.data.data)
                 conversation(receiverId,id)

            } catch (err) {
                console.error("Error fetching conversation:", err);
            }
    }

    useEffect(()=>{
          setReceveurNode(newConversation.find(m=>m.Customers_Numbers === data.userId));
    },[newConversation])


    const submit = async (e) => {
      e.preventDefault();
      //setLoading(true);
      setOpen(false); // Fermer le modal si ouvert
      

      e.preventDefault();
        const formData = new FormData();
        formData.append('msg', comment ? comment : message);
        formData.append('sender', data.userId);
        formData.append('recever', receive?.Customers_Numbers);
        formData.append('doc_file', docFile);
        formData.append('file', selectedFile);
       

      try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/messages`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (res.data.status === 201) {
          setMessage(''); 
          setComment(''); 
           // On convertit l'objet {3: [...], 5: [...]} en un tableau à plat
            //console.log("Message envoyé avec succès :", res.data.result);
            let messageData = res.data.result.messages;
            const rawData = res.data.mes || {};
            const messages = Object.values(rawData).flat();

          
          const ObjectNode = {
            id: res.data.result.inserted_id,
            respondent_az_id: messages[0]?.respondent_az_id,
            id_message_sent: data.userId,
            customer_number: data?.userId,
            Names: data?.userName,
            date:messages[0]?.date_conversation,
            LastName: data?.userLastname,
            Picture: receveurNode?.Picture ? `data:image/png;base64,${receveurNode.Picture}` : Image_Profil_User,
            message: comment ? comment : message,
            unread_messages_count: 1
          }
          
            // Si ce n’est pas un tableau, on le met dans un tableau
            if (!Array.isArray(messageData)) {
              messageData = [messageData];
            }

            const messageObject = messageData.find(m => m.id_conversation === res.data.result.inserted_id);
            //console.log("Message Object:", messageObject);
            // tu réémettras ce message complet via socket
            setConversations((prev) => ({
            ...prev,
            messages: prev.messages ? [...prev.messages, messageObject] : [messageObject]
           }));
            socket.emit('send_message', messageObject);
            socket.emit('sendersSent',ObjectNode)
            setSenders(messages);

        }

  } catch (error) {
    console.error('Erreur lors de l’envoi du message :', error);
  }
   };


  useEffect(() => {
  const handleMessageSent = (message) => {
    setConversations((prev) => ({
      ...prev,
      messages: prev.messages ? [...prev.messages, message] : [message]
    }));
  };

  const handleSendersSent = (message) => {
  //console.log("Message reçu dans handleSendersSent:", message);

  setSenders((prev) => {
    console.log("Message ancien ",prev)
   const userId = message.id_message_sent; // Ton ID utilisateur actuel
 // const interlocutorId = message.sender_id === userId ? message.receiver_id : message.sender_id;
    const existingSender = prev.find(sender => sender.respondent_az_id === userId);
    
    if (existingSender) {
      return prev.map(sender =>
        sender.respondent_az_id === message.id_message_sent
          ? {
              ...sender,
              message: message.message,
              //unread_messages_count: (sender.unread_messages_count || 0) + 1,
            }
          : sender
      );
    } else {
      return [
        ...prev,
        {
          LastName: message.LastName,
          Names: message.Names,
          Picture: message.Picture ?? message.senderPicture, // fallback
          customer_number: message.customer_number,
          date: message.date_conversation,
          id: message.id,
          id_message_sent: message.id_message_sent,
          message: message.message,
          respondent_az_id: message.respondent_az_id,
        }
      ];
    }
  });
};


  socket.on('messageSent', handleMessageSent);
  socket.on('sendersSent', handleSendersSent);

  return () => {
    socket.off('messageSent', handleMessageSent);
    socket.off('sendersSent', handleSendersSent);
  };
}, [socket]);



  useEffect(() => {

    if (!data) {
      navigate("/Connexion");
    }

    NewConversation()
    //getReceiverMessages();
    getSenderMessages();
    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, [data]);

  useEffect(()=>{
    conversation(data.userId,receive?.Customers_Numbers)

    if(searchP.trim() === '')
    {
      setNewConversation(originalConversations)
    }else{
      const filtered = originalConversations.filter((conv)=>{
        const name = conv?.Names ? conv?.Names : "";
        const lastname = conv?.LastName ? conv?.LastName : "";

        return (
          name.toLowerCase().includes(searchP.toLowerCase()) || 
          lastname.toLowerCase().includes(searchP.toLowerCase())
        )
      })
      setNewConversation(filtered)
    }
    
  },[comment,searchP,originalConversations])


const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return

  const fileType = file.type;

  if (fileType.startsWith("image/")) {
    const reader = new FileReader();
    reader.onload = () => {
      setImageData(reader.result); // pour affichage
      setFilFront(reader.result);  // base64 pour message socket
      setSelectedFile(file);       // ✅ vrai fichier à envoyer à Laravel
      setOpen(true);
  };
  reader.readAsDataURL(file);
}
 else if(fileType === 'application/pdf') {
      const pdfUrl= URL.createObjectURL(file);
      setImageData(pdfUrl); // Pour prévisualisation dans modal
      setFilFront(file);  // Pour envoi plus tard
      setOpen(true);
      setDocFile(file); // Pour envoi plus tard
  }else{
    alert("Veuillez sélectionner une image ou un fichier PDF.");
    return;
  }
};


useEffect(() => {
  const socket = io("http://localhost:3001", {
    withCredentials: true
  });

  socket.on("connect", () => {
    console.log("🔌 Connecté au serveur :", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.warn("❌ Déconnecté :", reason);
  });

  return () => socket.disconnect();
}, []);

// useEffect(()=>{
//   console.log("conversaction ",conversations);
// },[conversations])


  return (
    <div className='flex flex-row bg-[#eeee] '>
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>

          <div className='w-screen h-screen barre_scroll'>
            {/* sidebar top  */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className='bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]'>
              <Breadcrumbs >
                <Link to="" className="opacity-60">
                  Messagerie
                </Link>

              </Breadcrumbs>
            </div>
            {/* container formulaire */}
            <div className='flex flex-row h-screen md:px-10 md:py-2 s:py-10'>

              {/* Barre des conversation */}
              <div className='bg-white barre_scroll w-1/4 md:h-[521px]  s:h-[521px] xs:h-[721px] divide-y '>

                <div className='md:text-xl xs:text-lg flex flex-row items-center justify-between font-semibold py-4 px-6 text-[#4E4E4E]'>
                  <p className='s:hidden xs:block'>Conversations</p>
                  <div className='relative'>
                    <button
                      className='relative w-10 h-10 font-sans text-xs font-medium text-center text-gray-900 uppercase align-middle transition-all rounded-lg select-none hover:bg-gray-900/10 active:bg-gray-900/20'
                      onClick={toggleMenu}
                    >
                      <MdPostAdd className='text-xl' />
                    </button>
                    {isMenuOpen && (
                      <div className='absolute right-0 z-10 w-48 mt-2 overflow-y-auto bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 max-h-60 hide-scrollbar'

                        >
                          <div className="flex flex-col space-y-3 justify-center items-center mt-2" >     
                                  <input
                                    type="text"
                                    name="nom"
                                    value={searchP}
                                    onChange={(e)=>setSearchP(e.target.value)}
                                    placeholder="Rechercher..."
                                    className="w-[150px] h-10 rounded"
                                  />
                                             
                          </div>
                        {newConversation?.length > 0 && newConversation.map((newconversation, index) => (
                          <div key={index} onClick={() => newDiscussion(receiverId,newconversation?.Customers_Numbers)} className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                            <div className="flex flex-col gap-1">
                              <div className="flex flex-row items-center space-x-3 font-semibold cursor-pointer">
                                {newconversation?.Picture ?
                                  <img src={`data:image/png;base64,${newconversation.Picture}`} alt='profil' className='w-6 h-6 rounded-full'/>
                                  :
                                  <img src={Image_Profil_User} alt='profil' className='w-6 h-6 rounded-full'/>
                                }
                                <div className='text-lg text-center'>
                                  {`${newconversation?.Names || ''} ${newconversation?.LastName || ''}`}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* conversation 1 */}
                {senders?.length > 0 && senders.map((message, index) => (
                    <div
                        onClick={() => conversation(receiverId, message?.customer_number)}
                        key={index}
                        className='flex items-center py-3 cursor-pointer md:flex-row md:space-x-4 s:flex-col hover:bg-slate-50 sm:px-6'
                      >
                        {message?.Picture ? (
                          <img
                              src={message.Picture ? `data:image/png;base64,${message.Picture}` : Image_Profil_User}
                              alt='profil'
                              className='rounded-full xs:w-12 xs:h-12 sm:w-10 sm:h-10 s:w-8 s:h-8'
                          />
                        ) : (
                            <img
                                src={Image_Profil_User}
                                alt='profil'
                                className='rounded-full xs:w-12 xs:h-12 sm:w-10 sm:h-10 s:w-8 s:h-8'
                            />
                        )}
                        <div className='flex w-full md:flex-col s:flex-col-reverse'>
                            <div className='flex items-center md:flex-row s:flex-col md:justify-between'>
                                <div className='text-center s:text-xs sm:text-lg'>
                                    {`${message?.Names || ''} ${message?.LastName || ''}`}
                                </div>
                                <div className='font-light'>
                                    {message?.last_message_time ? new Date(message.last_message_time).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    }) : ''}
                                </div>
                            </div>
                            <div className='flex flex-row items-center pt-2 space-x-2'>
                                <div className='italic font-light s:hidden md:block'>{message?.message !== 'string' ? message?.message : ""}</div>
                                <div className='w-6 h-5 bg-[#FE7F2D] text-sm rounded-full text-white text-center relative xs:left-[47px] md:left-0'>
                                    {message?.unread_messages_count || ''}+
                                </div>

                            </div>
                        </div>
                    </div>
                ))}

              </div>

              <div className='w-3/4 '>

                <div className='flex items-center justify-between px-2 bg-white h-14' >

                  {receive && Object.keys(receive).length !== 0 ? (
                      <div className='flex flex-row items-center space-x-3'>
                        <img
                            src={receive?.Picture ? `data:image/png;base64,${receive?.Picture}` : Image_Profil_User}
                            alt='profil'
                            className='w-10 h-10 rounded-full'
                        />

                          <div className='text-center s:text-xs sm:text-lg'>
                              {`${receive?.Names || ''} ${receive?.LastName || ''}`}
                          </div>
                      </div>
                  ) : (
                      <div className='flex flex-row items-center space-x-3'>

                      </div>
                  )}
                  <Tooltip content="Action">
                    <IconButton variant="text">
                      <Menu>
                        <MenuHandler>
                          <IconButton variant='text'>
                            <RxDotsVertical className='text-lg' />
                          </IconButton>
                        </MenuHandler>
                        <MenuList className="flex flex-col gap-2">
                          {/* supprimer */}
                            <Link to="">
                              <MenuItem className="flex items-center gap-4 py-2 pl-2 pr-8 hover:bg-gray-100">
                                <div className="flex flex-col gap-1">
                                    <Typography variant="small" color="gray" className="font-semibold">
                                      supprimer
                                    </Typography>
                                  </div>
                              </MenuItem>
                            </Link>
                        </MenuList>
                      </Menu>
                    </IconButton>
                  </Tooltip>

                </div>

                {/* conversation */}
                <div className='p-6 barre_scroll md:h-[410px] s:h-[410px] xs:h-[610px]  flex-col flex space-y-8'>

                 {/* Modal file */}
                  {open && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg p-6 w-[600px]  relative h-[500px] overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                          onClick={() => setOpen(false)}
                          className="absolute top-3 right-3 text-red-500 text-2xl"
                        >
                          &times;
                        </button>
                        
                        <div className="">
                        
                            <div className="relative" id="imgIns">
                                  
                              {fileFront?.type === "application/pdf" ? (
                                 <iframe
                                    src={imageData}
                                    title="Aperçu PDF"
                                    width="100%"
                                    height="400px"
                                    className="mx-auto"
                                    
                                  />
                                ) : (
                                  <img
                                    src={imageData}
                                    alt="Aperçu"
                                    className="max-w-full h-auto mx-auto"
                                  />
                                )}
                            </div>


                            {/* Zone de texte */}
                            <form onSubmit={submit} className="flex flex-col items-center">
                             <div class="flex flex-row items-center justify-between space-x-2 mt-4">
                                  <textarea
                                        value={message}
                                        onChange={(e) => setMessage(e.currentTarget.value)}
                                        name='msg'
                                        className='s:w-[160px] sm:w-[220px] xs:w-[500px] md:w-[500px] h-14 border-none p-4 bg-transparent'
                                        placeholder='Taper un message'
                                    />
                                    {/* Bouton envoyer */}
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`${loading ? 'cursor-not-allowed' : ''}`}
                                    >
                                        {loading ? 'Loading...' : <VscSend className='text-xl' />}
                                    </button>
                            </div>
                            </form>
                           
                              
                          
                        </div>
                      </div>
                    </div>
                  )}


                {(conversations?.messages?.length > 0 && receive && Object.keys(receive).length !== 0) ? (
                    conversations.messages.map((msg, idx) => (
                        <div>
                            <div key={idx} className={`grid ${msg.id_message_sent === receiverId ? 'place-items-end' : ' place-items-start'}`}>
                                <div className='flex flex-row items-end space-x-3 group relative'>
                                    <FaChevronDown onClick={()=>setBulb(!bulb)} className={`hidden group-hover:block text-sm text-black cursor-pointer `} />
                                     

                                    {msg.made_by === receiverId && (

                                        <img
                                            src={conversations.sender.Picture ? `data:image/png;base64,${conversations.sender.Picture}` : Image_Profil_User}
                                            alt='profil'
                                            className='w-6 h-6 rounded-full'
                                        />
                                    )}
                                    <div className={`min-w-[80px] max-w-[400px] rounded-lg shadow-lg h-full p-3 ${msg.id_message_sent === receiverId ? 'bg-[#FE7F2D] text-white' : 'bg-[#233D4D] text-white'}`}>
                                       {msg?.file && typeof msg.file === "string" && (
                                            <div className="space-y-2">
                                                {/* ✅ Aperçu de l'image */}
                                                <img
                                                src={
                                                    msg.file.startsWith("data:image")
                                                    ? msg.file
                                                    : `data:image/png;base64,${msg.file}`
                                                }
                                                alt="image"
                                                className="max-w-full rounded"
                                                />

                                                {/* ✅ Lien de téléchargement */}
                                                <a
                                                href={
                                                    msg.file.startsWith("data:image")
                                                    ? msg.file
                                                    : `data:image/png;base64,${msg.file}`
                                                }
                                                download={`image-${msg.id_conversation || 'fichier'}.png`}
                                                className="text-sm text-white-600 hover:underline"
                                                >
                                                 <FiDownload className="text-2xl" />
                                                </a>
                                            </div>
                                        )}

                                        {msg.doc_file && (
                                            <div>
                                                {/* Aperçu PDF */}
                                                <a
                                                href={`data:application/pdf;base64,${msg.doc_file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                >
                                                <iframe
                                                    src={`data:application/pdf;base64,${msg.doc_file}`}
                                                    title="Aperçu PDF"
                                                    width="100%"
                                                    height="400px"
                                                    className="mx-auto"
                                                />
                                                </a>

                                                {/* ✅ Lien de téléchargement */}
                                                <div className="mt-2 text-sm text-white-600 hover:underline mb-4">
                                                <a
                                                    href={`data:application/pdf;base64,${msg.doc_file}`}
                                                    download={`document-${msg.id_conversation || 'pdf'}.pdf`}
                                                >
                                                    <FiDownload className="text-2xl" />
                                                </a>
                                                </div>
                                            </div>
                                        )}


                                        <div>
                                            <div className="flex items-center space-x-1">
                                                <span>{msg.message !== 'string' ? msg.message : ""}</span>
                                           </div>
                                        </div>
                                        {new Date(msg.date_conversation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                    {msg.id_message_sent !== receiverId && (
                                    <img
                                            src={conversations?.receiver?.Picture ? `data:image/png;base64,${conversations.receiver.Picture}` : Image_Profil_User}
                                            alt='profil'
                                            className='w-6 h-6 rounded-full'
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div>Aucun message à afficher</div>
                )}

                </div>

                 {/* Input conversation */}
                  
                   <div className='flex items-center justify-between px-2 bg-white h-14'>
                    <div className='flex flex-row items-center space-x-3'>
                        <form onSubmit={submit} className="flex items-center space-x-2">
                       
                        {/* Zone de texte */}
                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.currentTarget.value)}
                            name='msg'
                            className='s:w-[160px] sm:w-[220px] xs:w-[500px] md:w-[900px] h-14 border-none p-4 bg-transparent'
                            placeholder='Taper un message'
                        />

                         
                        {/* Champ fichier */}
                        <label className="cursor-pointer">
                            📎
                            <input
                            type="file"
                            onChange={handleFileChange}
                            accept="image/*,application/pdf"
                            className="hidden"
                            />
                        </label>


                        {/* Bouton envoyer */}
                        <button
                            type="submit"
                            disabled={loading}
                            className={`${loading ? 'cursor-not-allowed' : ''}`}
                        >
                            {loading ? 'Loading...' : <VscSend className='text-xl' />}
                        </button>
                        </form>
                    </div>
                    </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Message